<template>
    <div class="FormInputContainer" :class="{ hasErrors: errorMessages }">
        <label v-if="label" :for="inputId">
            {{ label }}<span v-if="required" class="required">*</span>
            <div v-if="sublabel" class="sublabel">{{ sublabel }}</div>
        </label>

        <slot/>
        <div v-if="errorMessages" class="errors">
            <div v-for="error in errorMessages" v-if="error">{{ error }}</div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'FormInputContainer',

    props: {
        inputId: { type: String },
        label: { type: String },
        sublabel: { type: String },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },

    computed: {
        errorMessages() {
            if (!this.errors) return null;

            const messages = this.errors.filter(error => error);
            return messages.length ? messages : null;
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormInputContainer {
    margin-bottom: 30px;
    text-align: left;

    &.hasErrors {
        color: $red-color;
        ::v-deep input,
        ::v-deep select {
            border-color: $red-color;
        }
    }

    &.marginless {
        margin-bottom: 0;
    }

    label {
        display: inline-block;
        margin-bottom: 5px;
        margin-left: 2px;
        font-weight: $font-weight-bold;

        div {
            font-weight: $font-weight-regular;
            color: $text-color-muted;
            font-size: 14px;
        }
    }

    .required {
        color: $red-color;
    }

    .errors {
        margin-top: 5px;
        margin-left: 3px;
        color: $red-color;
    }
}
</style>
